import ScanApi from "./../api/scan";

export const GET_SCAN_DATA_REQUESTED = "scan/GET_SCAN_DATA_REQUESTED";
export const GET_SCAN_DATA = "scan/GET_SCAN_DATA";
export const DOWNLOAD_SCAN_XLS = "scan/DOWNLOAD_SCAN_XLS";
export const GET_SCAN_RANGES_REQUESTED = "scan/GET_SCAN_RANGES_REQUESTED";
export const GET_SCAN_RANGES = "scan/GET_SCAN_RANGES";

const initialState = {
  data: {},
  isLoading: false,
  hasData: false,
  ranges: [],
  hasRanges: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_SCAN_DATA_REQUESTED:
      return {
        ...state,
        isLoading: true
      };

    case GET_SCAN_DATA:
      return {
        ...state,
        isLoading: false,
        hasData: true,
        data: action.data
      };

    case GET_SCAN_RANGES_REQUESTED:
      return state;

    case GET_SCAN_RANGES:
      return {
        ...state,
        hasRanges: true,
        ranges: action.data
      };
    default:
      return state;
  }
};

export const getScanData = config => {
  return dispatch => {
    dispatch({
      type: GET_SCAN_DATA_REQUESTED
    });

    if (process.env.NODE_ENV === "development") {
      return ScanApi.getFakeData(config)
        .then(data => {
          dispatch({
            type: GET_SCAN_DATA,
            data
          });
        })
        .catch(error => {
          throw error;
        });
    } else {
      return ScanApi.getData(config)
        .then(data => {
          dispatch({
            type: GET_SCAN_DATA,
            data
          });
        })
        .catch(error => {
          throw error;
        });
    }
  };
};

export const getScanRanges = config => {
  return dispatch => {
    dispatch({
      type: GET_SCAN_RANGES_REQUESTED
    });

    if (process.env.NODE_ENV === "development") {
      return ScanApi.getFakeRanges(config)
        .then(data => {
          console.log(data);
          dispatch({
            type: GET_SCAN_RANGES,
            data
          });
        })
        .catch(error => {
          throw error;
        });
    } else {
      return ScanApi.getRanges(config)
        .then(data => {
          dispatch({
            type: GET_SCAN_RANGES,
            data
          });
        })
        .catch(error => {
          throw error;
        });
    }
  };
};

export const downloadScanXls = () => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_SCAN_XLS
    });
  };
};



// WEBPACK FOOTER //
// ./src/modules/scan.js